import { FormHelperText, MenuItem, Select } from "@mui/material";
import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { ApiUrl } from "../../../utils/ApiUrl";

interface IScheduleField {
  setScheduleId: (x: any) => void;
  setScheduleTime: (x: any) => void;
  setDisableDestination: (x: any) => void;
  pickUpDate: Date;
  input: string;
  setInput: (x: string) => void;
  id: string;
  name: string;
  error: any;
  helperText: any;
}

const ScheduleField = ({
  setScheduleId,
  setScheduleTime,
  setDisableDestination,
  pickUpDate,
  id,
  name,
  setInput,
  input,
  error,
  helperText,
}: IScheduleField) => {
  var customParseFormat = require("dayjs/plugin/customParseFormat");
  dayjs.extend(customParseFormat);
  const [scheduleList, setScheduleList] = useState([]);

  const GetScheduleList = () => {
    return axios
      .request({
        method: "GET",
        url: `${ApiUrl}/scheduleSummaries`,
        params: {
          PickUpDate: dayjs(pickUpDate).format("YYYY-MM-DD"),
          PageNumber: 1,
          PageSize: 1000,
        },
        // headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setScheduleList(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    GetScheduleList();
  }, [pickUpDate]);

  return (
    <>
      <Select
        displayEmpty
        id={id}
        name={name}
        value={input || ""}
        className="md:min-w-[200px] min-w-[100%]"
        onChange={(event) => {
          var scheduleFind: any = scheduleList.find(
            (option: any) => option.time === event.target.value
          );
          setScheduleId(scheduleFind.id);
          setScheduleTime(scheduleFind.time);
          scheduleFind.id
            ? setDisableDestination(false)
            : setDisableDestination(true);
          setInput(event.target.value);
        }}
        error={error}
        size="small"
      >
        <MenuItem disabled value="">
          <p className="text-[#a9a9a9]">Select Time</p>
        </MenuItem>
        {scheduleList.map((item: any) => (
          <MenuItem style={{ whiteSpace: "normal" }} value={item.time}>
            {item.time}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default ScheduleField;
